import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import api from '../../api';

const POLL_INTERVAL = 2000;

@inject('commonStore', 'orderStore', 'menuStore')
@observer
class Result extends Component {
  pollTimeout = null;
  dotsInterval = null;

  // status: 'polling' | 'approving'
  state = { dots: '', status: 'polling' };

  componentDidMount() {
    const { orderStore } = this.props;

    this.dotsInterval = setInterval(() => {
      this.setState(prev => ({ dots: prev.dots.length >= 3 ? '' : prev.dots + '.' }));
    }, 500);

    const { paymentUrl, kakaoAppScheme } = orderStore.orderAuthData || {};

    // 이동 대상 결정: kakaoAppScheme이 있으면 우선, 없으면 paymentUrl(앱스킴 또는 웹 URL일 수 있음)
    const target = kakaoAppScheme || paymentUrl;

    if (target) {
      if (/^https?:\/\//i.test(target)) {
        window.location.replace(target);
      } else {
        window.location.href = target;
      }
    }

    setTimeout(() => this.startPolling(), 3000);
  }

  componentWillUnmount() {
    clearInterval(this.dotsInterval);
    clearTimeout(this.pollTimeout);
  }

  startPolling = () => {
    const { menuStore, orderStore } = this.props;

    this.pollTimeout = setTimeout(async () => {
      try {
        const response = await api
          .getOrderStatus(
            menuStore.storeData.companyId,
            menuStore.storeData.storeCode,
            orderStore.orderAuthData.orderId,
          )
          .then(r => r.data);

        if (response.status === 'RECEIVED') {
          await this.approve();
          return;
        }
      } catch (error) {
        console.error(error);
      }

      this.startPolling();
    }, POLL_INTERVAL);
  };

  approve = async () => {
    const { match, history } = this.props;
    const { companyId, storeCode, orderId } = match.params;

    this.setState({ status: 'approving' });

    try {
      const response = await api.approveNicepayVan(companyId, storeCode, orderId).then(r => r.data);
      history.push(`/${companyId}/${storeCode}/orders/${response.orderId}/complete`);
    } catch (error) {
      console.error(error);
      this.setState({ status: 'polling' });
      this.startPolling();
    }
  };

  handleCancel = () => {
    const { history } = this.props;
    clearTimeout(this.pollTimeout);
    history.goBack();
  };

  render() {
    const { dots, status } = this.state;
    const { t } = this.props;

    return (
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
          gap: 4,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: '#0070CD',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 20px rgba(0, 112, 205, 0.35)',
          }}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="5" width="20" height="14" rx="2" stroke="white" strokeWidth="2" />
            <path d="M2 10H22" stroke="white" strokeWidth="2" />
            <rect x="5" y="14" width="4" height="2" rx="0.5" fill="white" />
          </svg>
        </Box>

        <CircularProgress size={56} thickness={3} sx={{ color: '#0070CD' }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#1a1a1a', letterSpacing: '-0.3px' }}>
            {t('payment.label.progress')}
            {dots}
          </Typography>
          <Typography sx={{ fontSize: '0.9rem', color: '#888', mt: 1 }}>{t('payment.label.wait')}</Typography>
        </Box>

        {/* approving 중에는 버튼 없음 */}
        {status === 'polling' && (
          <Button variant="outlined" onClick={this.handleCancel} sx={{ color: '#888', borderColor: '#ccc', mt: 1 }}>
            {t('payment.button.cancel')}
          </Button>
        )}
      </Box>
    );
  }
}

export default withRouter(withTranslation()(Result));
